import React from 'react';

import {observer} from 'mobx-react';
import useTimeout from '../../helpers/useTimeout';
import styles from './ScreenSwiper.module.scss';
import SlideSwiper from './SlideSwiper';
import classNames from 'classnames';
import {useStore} from '../../components/StoreProvider';

interface ScreenSwiperProps {
    slideNumber?: number;
    notDetectHeight?: boolean;
    navButtons?: React.ReactElement;
    onTransitionEnd?: () => void;
    automaticNextSlide: () => void;
    noTopAnimation?: boolean;
    disableOverflow?: boolean;
    children?: React.ReactNode;
}

const transitionLength = 600;

const ScreenSwiper: React.FC<ScreenSwiperProps> = ({
    children,
    slideNumber,
    onTransitionEnd = () => undefined,
    automaticNextSlide,
    disableOverflow = false,
}) => {
    const slides = React.Children.toArray(children);
    const store = useStore();
    const {progressStore} = store.uiStore;

    useTimeout(onTransitionEnd, transitionLength, [slideNumber]);

    return (
        <div
            className={classNames(styles.container, {
                [styles.overflow]: progressStore.phase !== 2 && !disableOverflow,
            })}
            data-testid={'screenSwiper'}
            style={{
                width: `calc(${slides.length} * 100vw)`,
                transition: `transform ${transitionLength}ms`,
                transform: `translateX(calc(-${slideNumber} * 100vw))`,
            }}
        >
            {slides.map((slide: React.ReactElement, i) => (
                <SlideSwiper
                    key={i}
                    active={i === slideNumber}
                    style={{width: '100vw'}}
                    automaticNextSlide={automaticNextSlide}
                >
                    {slide}
                </SlideSwiper>
            ))}
        </div>
    );
};

export default observer(ScreenSwiper);
